"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _browserCookies = _interopRequireDefault(require("browser-cookies"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

/**
 * get cookie, both server and client side
 * @param name
 * @param req
 */
var getCookie = function getCookie(name, req) {
  if (req) {
    return req.cookies[name];
  }
  return _browserCookies["default"].get(name);
};
var _default = getCookie;
exports["default"] = _default;